/**
 * Processes DynamicLine objects in a canvas without re-rendering
 * @param {fabric.Canvas} canvas - The fabric canvas instance
 * @return {fabric.Canvas}
 */
export function processDynamicLines(canvas) {
  if (!canvas) {
    console.warn('Canvas instance not provided to processDynamicLines');
    return;
  }

  const canvasObjects = canvas.getObjects();
  canvasObjects.forEach((obj) => {
    if (obj.type === 'DynamicLine') {
      obj.set({
        left: obj.left,
        top: obj.top,
        pathOffset: { x: 0, y: 0 },
      });
    }
  });

  return canvas;
}
